export const ContentfulCredentials = {
  space: process.env.XCONTENT_SPACE_ID || '4f3rgqwzdznj',
  accessToken: process.env.XCONTENT_ACCESS_TOKEN_DELIVERY || 'dGwWmwdX_fm4Kb0idRZ4vK_gPc5GynMvbM8Nh2xwbvU',
  previewAccessToken: process.env.XCONTENT_ACCESS_TOKEN_PREVIEW || '0JqDbdEbdLDBTZSLU6lL3bgd3A2eAMIryzHGH0DJZcw',
  environment: process.env.XCONTENT_ENVIRONMENT || 'master',
};
